/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EnforceIcon extends BaseIcon {
  getChildren = () => [ <g><g><path d="M8,16a8,8,0,0,0,8-8A8,8,0,0,0,8,0,8,8,0,0,0,0,8,8,8,0,0,0,8,16ZM2.29,7.4l4.8-5A1.47,1.47,0,0,1,8,2a1,1,0,0,1,.8.36l4.91,5a1.2,1.2,0,0,1,0,1.68,1.07,1.07,0,0,1-1.6,0l-3-3V12.8A1.1,1.1,0,0,1,8,14a1.1,1.1,0,0,1-1.14-1.2V6.08L4,9.08a1.07,1.07,0,0,1-1.6,0A1.31,1.31,0,0,1,2.29,7.4Z" fill={this.getColor()}/></g></g> ]
  getViewBox = () => '0 0 16 16'
}
